module.exports = {
      id: "loupe-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#loupe",
      toString: function () {
        return this.url;
      }
    }